/***************************************************
 * Created by gongyanyu on 2022/10/18 17:21. *
 ***************************************************/
import { ViewModel } from '../interfaces/ViewModel';
import { IModelConstructor } from '../interfaces/IModelConstructor';

export function isViewModel(obj: typeof ViewModel | IModelConstructor<any>): true;
export function isViewModel(obj: any): false;
export function isViewModel(obj: any): boolean {
  return isOfType(obj, ViewModel);
}

function isOfType<T>(obj: any, type: T): obj is T {
  let model = obj;

  while (model) {
    if (model === type) return true;
    model = Object.getPrototypeOf(model);
  }

  return false;
}
